import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const RestoreMeetingPrepStoryMutation = graphql(`
  mutation RestoreMeetingPrepStory($id: ID!) {
    restoreMeetingPrepStory(id: $id) {
      id
      __typename
      clientId
      storyKey
      status
      endedAt
    }
  }
`);

export function useRestoreMeetingPrepStory() {
  const [result, restoreMeetingPrepStoryMutation] = useMutation(RestoreMeetingPrepStoryMutation);
  const [error, setError] = useState<Error | null>(null);

  const restoreMeetingPrepStory = useCallback(
    async (id: string) => {
      try {
        const response = await restoreMeetingPrepStoryMutation({ id });
        if (response.error) {
          throw response.error;
        }
        return response.data?.restoreMeetingPrepStory;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [restoreMeetingPrepStoryMutation],
  );

  return { restoreMeetingPrepStory, result, error };
}
